import { CheckIcon } from "@chakra-ui/icons";
import {
  Flex,
  List,
  ListItem,
  ListIcon,
  ComponentWithAs,
  IconProps,
  ListProps,
} from "@chakra-ui/react";
import { FC } from "react";

export type ReivListProps = {
  data: { description: string | JSX.Element; icon?: ComponentWithAs<"svg", IconProps> }[];
};

const ReivList: FC<ListProps & ReivListProps> = ({
  data,
  children,
  ...rest
}) => {
  return (
    <List spacing={3} padding="8px" {...rest}>
      {data.map(({ description, icon }) => (
        <ListItem>
          <Flex>
            <ListIcon marginTop="0.3rem" marginRight="0.75rem" as={icon || CheckIcon} color="brand.500" />
            {description}
          </Flex>
        </ListItem>
      ))}
    </List>
  );
};

export default ReivList;
